// Create new file: billing-plugin/common/schemas/collections/paymentRequests.js

import { z } from "zod";

const PaymentRequestSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),

    // Context
    subscriptionId: z.string().describe("The subscription this payment is for."),
    userId: z.string().describe("The user who initiated or is responsible for this payment."),

    initiatingAgentName: z.string().optional().nullable()
        .describe("The name of the agent that initiated this payment request."),
    initiatingContext: z.record(z.any()).optional().nullable()
        .describe("The full context of the agent at the time of initiation (e.g., { conversationId, projectId, omnixContext })."),

    // Payment Details
    amount: z.number().int().positive().describe("Amount in the smallest currency unit (e.g., cents)."),
    currency: z.string().length(3).describe("ISO 4217 currency code."),
    description: z.string().optional(),

    // Status & Lifecycle
    status: z.enum(['pending', 'paid', 'failed', 'expired']).default('pending'),

    // Gateway Information
    gatewayName: z.string().describe("The name of the payment gateway used (e.g., 'razorpay')."),
    gatewayOrderId: z.string().optional().nullable().describe("The order/link ID from the payment gateway."),
    paymentLinkUrl: z.string().url().optional().nullable().describe("The short URL for the user to complete payment."),

    // Timestamps
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    paidAt: z.coerce.date().optional().nullable(),
    expiresAt: z.coerce.date().optional().nullable(),
});

export default PaymentRequestSchema;